/** Main entry point **/
import React, { Suspense, lazy } from "react";
import { Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import * as loginReducer from "containers/Login/reducer";
import * as viewReducer from "containers/View/reducer";

import Login from "containers/Login/Login";
import Registration from "containers/Registration/Registration";
import Logout from "containers/Login/Logout";
import Reset from "containers/Reset/Reset";
import ResetSuccess from "containers/Reset/ResetSuccess";
import UploadPage from "components/UploadPage/UploadPage";

const ProtectedApp = lazy(() => import("containers/App/ProtectedApp"));

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { VIEW_BREAKPOINTS } from "containers/View/reducer";

class AppContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    const { screenType, updateScreenType } = this.props;

    if (window.innerWidth <= 1024 && screenType === "desktop") {
      updateScreenType("mobile");
    }
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    const { screenType, updateScreenType } = this.props;

    if (window.innerWidth <= VIEW_BREAKPOINTS.mobile && screenType === "desktop") {
      updateScreenType("mobile");
    } else if (window.innerWidth > VIEW_BREAKPOINTS.mobile && screenType !== "desktop") {
      updateScreenType("desktop");
    }
  }

  render() {
    return (
      <Suspense fallback={<LoadingIndicator style={{ height: "100vh", margin: "45vh auto" }} />}>
        <Switch>
          <Route path="/logout" component={Logout} />
          <Route path="/login/:type" component={Login} />
          <Route path="/login" component={Login} />
          <Route path="/registration/:inviteToken" component={Registration} />
          <Route path="/registration" component={Registration} />
          <Route path="/resetsuccess" component={ResetSuccess} />
          <Route path="/reset" component={Reset} />
          <Route exact path="/upload/:id" component={UploadPage} />
          <Route path="*" component={ProtectedApp} />
        </Switch>
      </Suspense>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  registerLooker: () => dispatch(loginReducer.registerLooker()),
  updateScreenType: (screenType) => dispatch(viewReducer.updateScreenType(screenType))
});

const mapStateToProps = (state, ownProps) => ({
  screenType: viewReducer.getScreenType(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(AppContainer);
